import moment from "moment";
import saveAs from "file-saver";
import _ from "lodash";
import { ExportExcelColor } from "../../../../../root/theme/exportColor";

/* Changing row colors */
const excelRawChangeColor = (data: any, index: number) => {
  if (data.isGroup) {
    return {
      argb: [ExportExcelColor.green],
    };
  }
  if (data.isDepartment) {
    return {
      argb: [ExportExcelColor.yellow],
    };
  }
  if (index % 2 === 0) {
    return {
      argb: [ExportExcelColor.OddRowColor],
    };
  } else {
    return {
      argb: [ExportExcelColor.EvenRowColor],
    };
  }
};

const changeFontColor = (data: any, index: number) => {
  if (data.isGroup) {
    return { color: { argb: "FFFFFF" }, bold: true };
  }
  if (data.isDepartment) {
    return { color: { argb: "000000" }, bold: true };
  }
  if (index % 2 === 0) {
    return { color: { argb: "FFFFFF" } };
  } else {
    return { color: { argb: "FFFFFF" } };
  }
};

/* Create new table */
const handleTable = (
  nodes: any,
  excelHeaders: any,
  worksheet: any,
  rowLength: any,
  nodeLength: any,
  footerLength: any,
) => {
  let excelHeader: any = {};
  let excelData: any = {};
  /* Worksheet add headers */

  /* Find the last character in the excel */
  const len = excelHeaders.length + 64;
  let char = String.fromCharCode(len);

  /* Add a headers and change the header and empty row height. */
  excelHeaders.map((data: any) => (excelHeader[data.key] = data.header));

  worksheet.getRow(1).height = 28;
  worksheet.getRow(2).height = 28;
  /* Add a body in the excel. */
  /* Add a body in the excel. */
  nodes.forEach((data: any, index: number) => {
    Object.keys(excelHeader).forEach((header: any) => {
      excelData[header] = data[header];
    });
    worksheet.addRow(excelData);
    // Change the alignment in the cell.
    const row = worksheet.getRow(index + rowLength);
    row.eachCell({ includeEmpty: true }, function (cell: any, colNumber: any) {
      let char = String.fromCharCode(64 + colNumber);
      worksheet.getCell(`A${index + rowLength})`).alignment = {
        vertical: "bottom",
        horizontal: "left",
      };
      if (char === "J") {
        worksheet.getCell(`J${index + rowLength})`).alignment = {
          vertical: "bottom",
          horizontal: "right",
        };
      } else {
        worksheet.getCell(`${char}${index + rowLength})`).alignment = {
          vertical: "bottom",
          horizontal: "center",
        };
      }

      // Change the font style in the specific cell.
      if (colNumber === 1) {
        worksheet.getCell(`${char}${index + rowLength})`).font = { bold: true };
      }
    });

    worksheet.getRow(index + rowLength).height = 28;
  });

  /* Change the footer color and styles */
  const row = worksheet.getRow(nodes.length + rowLength);
  row.eachCell({ includeEmpty: true }, function (cell: any, colNumber: any) {
    let char = String.fromCharCode(64 + colNumber + 1);
    if (char === "J") {
      worksheet.getCell(`${char}${nodes.length + rowLength})`).alignment = {
        vertical: "bottom",
        horizontal: "right",
      };
    } else {
      worksheet.getCell(`${char}${nodes.length + rowLength})`).alignment = {
        vertical: "bottom",
        horizontal: "center",
      };
    }

    // Change the font style in the specific cell.
    if (colNumber === 1) {
      worksheet.getCell(`A${nodes.length + rowLength})`).font = { bold: true };
    }
  });

  /* Change the footer height */
  worksheet.getRow(nodes.length + rowLength).height = 28;

  /* Change the title style */
  worksheet.addConditionalFormatting({
    ref: "A1",
    rules: [
      {
        type: "expression",
        formulae: ["MOD(2,2)=0"],
        style: {
          fill: {
            type: "pattern",
            pattern: "solid",
          },
          font: { bold: true, size: 10 },
        },
      },
    ],
  });

  /* Change the sub title stile */
  worksheet.addConditionalFormatting({
    ref: `B1:${char}1`,
    rules: [
      {
        type: "expression",
        formulae: ["MOD(2,2)=0"],
        style: {
          fill: {
            type: "pattern",
            pattern: "solid",
          },
          font: {
            bold: true,
            size: 10,
          },
        },
      },
    ],
  });

  /* Change all row colors. */
  nodes.forEach((data: any, index: any) => {
    worksheet.addConditionalFormatting({
      ref: `A${index + rowLength}:${char}${index + rowLength}`,
      rules: [
        {
          type: "expression",
          formulae: ["MOD(2,2)=0"],
          style: {
            fill: {
              type: "pattern",
              pattern: "solid",
              bgColor: excelRawChangeColor(data, index),
            },
            font: changeFontColor(data, index),
          },
        },
      ],
    });
  });

  /* Bold the letters in the first column. */
  const column = worksheet.getColumn(1);
  column.style = { font: { bold: true } };
};

/* Create a excel file */
export const handleExcel = (
  excelHeaders: any,
  nodes: any,
  filterDetails: any,
) => {
  const ExcelJS = require("exceljs");
  const workbook = new ExcelJS.Workbook();

  const worksheet = workbook.addWorksheet("Stock Movements Report");

  /* Worksheet add headers */
  worksheet.columns = excelHeaders;

  /* Find the last character in the excel */
  const len = excelHeaders.length + 64;
  let char = String.fromCharCode(len);

  /* Add a title */
  worksheet.getCell("A1").value = "Stock Movements report";

  worksheet.mergeCells(`B1:${char}1`);

  const splitFilter = filterDetails.split("*");
  let filterOptions = "";

  /* Change of sub-title according to the number of locations.
  If the location is one, then that location is displayed, 
  if more than one location, the number of locations is displayed. */
  if (splitFilter[0].split(",").length === 1) {
    filterOptions =
      "Stock Movements Summary Report for " +
      splitFilter[0].split(",")[0] +
      " " +
      "Generated for the period of " +
      splitFilter[1];
  } else {
    filterOptions =
      "Stock Movements Summary Report for " +
      splitFilter[0].split(",").length +
      " Locations " +
      "Generated for the period of " +
      splitFilter[1];
  }

  /* Add sub-title using filter options. */

  worksheet.getCell("B1").value = filterOptions;

  /* Add a empty row. */
  let rowLength = 3;
  nodes.forEach((value: any) => {
    if (!_.isEmpty(value)) {
      //   worksheet.addRow({});
      worksheet.getCell(`A${rowLength}`).font = { bold: true };
      worksheet.getRow(rowLength).height = 28;
      let data: any = [];
      if (value.isGroup || value.isDepartment) {
        data.push(value);
      } else {
        data = value.pdfData;
      }
      rowLength = rowLength + 1;

      handleTable(data, excelHeaders, worksheet, rowLength, data.length, 0);
      rowLength = rowLength + data.length;
    }
  });

  const today = moment().format("MMM_Do_YY").toString();
  workbook.xlsx.writeBuffer().then(function (buffer: any) {
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      `stock_movements_report_${today}_${Math.floor(
        100000 + Math.random() * 900000,
      )}.xlsx`,
    );
  });
};
